var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultimediaError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    viewBox: "0 0 15 14",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 3c0-1.38071 1.11929-2.5 2.5-2.5h5c1.38071 0 2.5 1.11929 2.5 2.5v1.02242c-2.80325.25262-5 2.60856-5 5.47758 0 .7056.13286 1.3801.37494 2h-2.87494c-1.38071 0-2.5-1.1193-2.5-2.5zm11 1.02242c1.1345.10223 2.1696.54895 3 1.23474v-2.75817c0-.42145-.4894-.65384-.816-.38746l-2.184 1.7813zm-5 5.47758c0 2.4853 2.01472 4.5 4.5 4.5 2.4853 0 4.5-2.0147 4.5-4.5 0-2.48528-2.0147-4.5-4.5-4.5-2.48528 0-4.5 2.01472-4.5 4.5zm1 0c0-1.933 1.567-3.5 3.5-3.5.7862 0 1.5118.2592 2.0961.69681l-4.89929 4.89929c-.43761-.5843-.69681-1.3099-.69681-2.0961zm3.5 3.5c-.78617 0-1.5118-.2592-2.09609-.6968l4.89929-4.89929c.4376.58429.6968 1.30992.6968 2.09609 0 1.933-1.567 3.5-3.5 3.5z",
    fill: "#373f41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultimediaError);
export default __webpack_public_path__ + "static/media/multimedia-error.607ef3b0eba0f19bd29b36b5438937ad.svg";
export { ForwardRef as ReactComponent };